import React from 'react';
import { motion } from 'framer-motion';
import { LinkedinIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  const coreprintLinks = [{
    label: 'Wat is CorePrint?',
    href: '#wat-is-coreprint'
  }, {
    label: 'Hoe het werkt',
    href: '#hoe'
  }, {
    label: 'Voor wie',
    href: '#voor-wie'
  }, {
    label: 'Early Access',
    href: '#bewijs'
  }, {
    label: 'Plan een presentatie',
    href: '#gesprek'
  }];
  const noordLinks = [{
    label: 'Over ons',
    href: 'https://noorddigital.nl/over-ons'
  }, {
    label: 'Ons team',
    href: 'https://noorddigital.nl/over-ons#team'
  }, {
    label: 'Cases',
    href: 'https://noorddigital.nl/#cases'
  }, {
    label: 'Blog',
    href: 'https://noorddigital.nl/bibliotheek'
  }, {
    label: 'Vacatures',
    href: 'https://noorddigital.nl/sollicitatie'
  }, {
    label: 'Webdesign Alkmaar',
    href: 'https://webdesignalkmaar.nl/',
    subtle: true
  }];
  return <footer style={{
    background: '#050A14',
    borderTop: '1px solid rgba(255, 255, 255, 0.05)'
  }} data-id="element-144">
      <div className="max-w-[1200px] mx-auto px-6 py-24" data-id="element-145">
        <div className="grid md:grid-cols-4 gap-14 mb-20" data-id="element-146">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-147">
            <div className="flex items-center gap-4 mb-4" data-id="element-148">
              <div className="text-white font-black text-2xl tracking-tight" data-id="element-149">
                Core<span className="text-brand-arctic" data-id="element-150">Print</span>
              </div>
              <motion.div className="relative group inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/5 border border-white/10 cursor-pointer" whileHover={{
              scale: 1.1,
              rotate: [0, -10, 10, -10, 0]
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-151">
                <img src="https://cdn.magicpatterns.com/uploads/fJjgNKZLLccSeJuGWQEqQf/Norden_groed_hallo.png" alt="Norden, de mascotte van Noord Digital, zwaait" className="w-9 h-9 object-contain opacity-90 group-hover:opacity-100 transition-opacity" data-id="element-152" />
                <div className="absolute -top-10 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity bg-brand-primary text-white text-xs font-bold py-1.5 px-3 rounded-lg whitespace-nowrap pointer-events-none z-10" data-id="element-153">
                  Norden zegt hoi 👋
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-brand-primary rotate-45" data-id="element-154"></div>
                </div>
              </motion.div>
            </div>

            <p className="text-white/40 text-sm leading-relaxed mb-7" data-id="element-155">
              Data-gedreven klantacquisitie voor B2B-bedrijven. Een dienst van{' '}
              <a href="https://noorddigital.nl" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white underline-offset-4 hover:underline transition-colors" data-id="element-156">
                Noord Digital
              </a>
              .
            </p>
            <div className="flex gap-3" data-id="element-157">
              {[{
              Icon: LinkedinIcon,
              href: 'https://www.linkedin.com/company/noord-digital'
            }, {
              Icon: InstagramIcon,
              href: 'https://www.instagram.com/noord_digital/'
            }].map(({
              Icon,
              href
            }, i) => <motion.a key={i} href={href} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-xl flex items-center justify-center transition-all" style={{
              border: '1px solid rgba(255, 255, 255, 0.08)',
              background: 'rgba(255, 255, 255, 0.02)'
            }} whileHover={{
              scale: 1.1,
              background: 'rgba(255, 255, 255, 0.08)',
              borderColor: 'rgba(0, 102, 255, 0.3)',
              transition: {
                type: 'spring',
                stiffness: 300
              }
            }} whileTap={{
              scale: 0.95
            }} data-id="element-158">
                  <Icon size={17} className="text-white/40" data-id="element-159" />
                </motion.a>)}
            </div>
          </div>

          {/* CorePrint */}
          <div data-id="element-160">
            <div className="text-white font-bold mb-6 text-sm" data-id="element-161">CorePrint</div>
            <div className="space-y-3.5" data-id="element-162">
              {coreprintLinks.map(l => <motion.a key={l.label} href={l.href} className="block text-white/40 hover:text-white text-sm transition-colors font-medium" whileHover={{
              x: 4
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 20
            }} data-id="element-163">
                  {l.label}
                </motion.a>)}
            </div>
          </div>

          {/* Noord Digital */}
          <div data-id="element-164">
            <div className="text-white font-bold mb-6 text-sm" data-id="element-165">
              Noord Digital
            </div>
            <div className="space-y-3.5" data-id="element-166">
              {noordLinks.map(l => <motion.a key={l.label} href={l.href} target={l.href.startsWith('http') ? '_blank' : '_self'} rel={l.href.startsWith('http') ? 'noopener noreferrer' : undefined} className={`block text-sm transition-colors font-medium ${l.subtle ? 'text-white/20 hover:text-white/40' : 'text-white/40 hover:text-white'}`} whileHover={{
              x: 4
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 20
            }} data-id="element-167">
                  {l.label}
                </motion.a>)}
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-168">
            <div className="text-white font-bold mb-6 text-sm" data-id="element-169">Contact</div>
            <div className="space-y-3.5 mb-8" data-id="element-170">
              <a href="#gesprek" className="block text-white/40 hover:text-white text-sm font-medium transition-colors" data-id="element-171">
                Gratis kennismaking
              </a>
              <a href="mailto:info@noorddigital.nl" className="block text-white/40 hover:text-white text-sm font-medium transition-colors" data-id="element-172">
                info@noorddigital.nl
              </a>
              <div className="text-white/40 text-sm font-medium" data-id="element-173">
                Alkmaar, Noord-Holland
              </div>
            </div>
            <motion.a href="#gesprek" className="inline-flex items-center gap-2.5 bg-brand-primary text-white font-bold text-sm px-6 py-3 rounded-2xl transition-all duration-500" whileHover={{
            scale: 1.05,
            boxShadow: '0 8px 32px rgba(0, 102, 255, 0.4)'
          }} whileTap={{
            scale: 0.95
          }} data-id="element-174">
              Plan een presentatie
            </motion.a>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-5" style={{
        borderTop: '1px solid rgba(255, 255, 255, 0.05)'
      }} data-id="element-175">
          <p className="text-white/25 text-sm font-medium" data-id="element-176">
            © 2026 Noord Digital B.V. · CorePrint is een dienst van{' '}
            <a href="https://noorddigital.nl" target="_blank" rel="noopener noreferrer" className="hover:text-white/50 transition-colors" data-id="element-177">
              Noord Digital
            </a>
          </p>
          <div className="flex gap-8" data-id="element-178">
            {[{
            label: 'Privacybeleid',
            href: 'https://noorddigital.nl/privacy'
          }, {
            label: 'Algemene Voorwaarden',
            href: 'https://noorddigital.nl/algemene-voorwaarden'
          }, {
            label: 'Cookiebeleid',
            href: 'https://noorddigital.nl/cookiebeleid'
          }].map(l => <motion.a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer" className="text-white/25 hover:text-white/50 text-sm transition-colors font-medium" whileHover={{
            y: -2
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 20
          }} data-id="element-179">
                {l.label}
              </motion.a>)}
          </div>
        </div>
      </div>
    </footer>;
}